/**
 * Full live pricing grid (rate × escalator) in a centered popup.
 */
import React from 'react';
import { createPortal } from 'react-dom';
import { PreContractLivePricingRail } from './PreContractLivePricingRail';
import type { PreContractIntakeForm } from '../lib/preContractTypes';
import type { PreContractPpwMetricsOverride } from '../lib/preContractPpwPricing';

export type PreContractLivePricingModalProps = {
    open: boolean;
    form: PreContractIntakeForm;
    onClose: () => void;
    metricsOverride?: PreContractPpwMetricsOverride | null;
    preferEnfinPartner?: boolean;
};

export const PreContractLivePricingModal: React.FC<PreContractLivePricingModalProps> = ({
    open,
    form,
    onClose,
    metricsOverride = null,
    preferEnfinPartner = false,
}) => {
    if (!open) return null;

    return createPortal(
        <>
            <button
                type="button"
                className="pci-pricing-modal__backdrop"
                aria-label="Close live pricing"
                onClick={onClose}
            />
            <div
                className="pci-pricing-modal pci-pricing-modal--amber pci-pricing-modal--live-grid"
                role="dialog"
                aria-modal="true"
                aria-label="Live pricing"
            >
                <PreContractLivePricingRail
                    form={form}
                    onClose={onClose}
                    metricsOverride={metricsOverride}
                    preferEnfinPartner={preferEnfinPartner}
                />
            </div>
        </>,
        document.body,
    );
};

export default PreContractLivePricingModal;
